/* ZYNOX — kaydırınca beliren bölümler (hafif, CSS öncelikli) */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq.matches) return;

  function mark() {
    var targets = document.querySelectorAll(
      '.shopify-section:not(.zx-hero-section) .multicolumn-card, ' +
      '.shopify-section:not(.zx-hero-section) .image-with-text__content, ' +
      '.shopify-section:not(.zx-hero-section) .collection__title, ' +
      '.shopify-section:not(.zx-hero-section) .card-wrapper'
    );
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        e.target.style.transitionDelay = (Math.min(i, 5) * 70) + 'ms';
        e.target.classList.add('zx-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    targets.forEach(function (el) {
      el.classList.add('zx-obs');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mark);
  } else {
    mark();
  }
})();
